import { useSessionStorage } from 'usehooks-ts';

import { DerivativesOrderSide, DerivativesPositionSide } from 'common/api/autogenerated/trading-gateway';

import { DerivativeOrderTypeEnum } from './types';

export const useSyncDerivativesOrdersList = (): [DerivativeOrderTypeEnum, (type: DerivativeOrderTypeEnum) => void] => {
  const [storageOrderType, updateStorageOrderType] = useSessionStorage(
    'webtrader:futures:order:type',
    DerivativeOrderTypeEnum.OPEN_POSITIONS,
  );

  return [storageOrderType, updateStorageOrderType];
};

export const isBuy = (side?: DerivativesOrderSide | DerivativesPositionSide) => side === DerivativesOrderSide.BUY;

export const isSell = (side?: DerivativesOrderSide | DerivativesPositionSide) => side === DerivativesOrderSide.SELL;

export const getFeeSign = (originalValue: number, formattedValue: string) => {
  if (+formattedValue === 0) return '';
  if (originalValue > 0) return '+';
  if (originalValue < 0) return '-';
  return '';
};

export const getPnlSign = (originalValue: number, formattedValue: string) => {
  if (+formattedValue === 0) return '';
  if (originalValue > 0) return '+';
  if (originalValue < 0) return '-';
  return '';
};
